import { Component, Input, OnInit } from '@angular/core';
import { CaseDetailStickyService } from '@app/core/services/case-detail-sticky/case-detail-sticky.service';

@Component({
  selector: 'app-detail-case-header-sticky',
  templateUrl: './detail-case-header-sticky.component.html',
  styleUrls: ['./detail-case-header-sticky.component.scss']
})
export class DetailCaseHeaderStickyComponent implements OnInit {
  @Input() idCase = '';

  constructor(private caseDetailStickyService: CaseDetailStickyService) {}

  ngOnInit() {}

  async download() {
    this.caseDetailStickyService.triggerDownloadPDF();
  }

  openSimilarPrincing() {
    this.caseDetailStickyService.triggerOpenSimilarPricing();
  }
}
